import { Component, OnInit, EventEmitter, } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ContractorHotWorkPermitService } from '../service/contractor-hot-work-permit.service';
import { AlertController, LoadingController, ModalController, Platform } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { HotWorkPermitSignatureType } from '../shared/enum/shared.enum';
import { Subscription } from 'rxjs';
import { AddSignatureModal } from '../workpermit/add-signature-modal/add-signature-modal.component';
import { finalize } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { TimeFormatPipe } from '../shared/pipe/time-format.pipe';
@Component({
  selector: 'app-contractor-hot-work-permit',
  templateUrl: './contractor-hot-work-permit.page.html',
  styleUrls: ['./contractor-hot-work-permit.page.scss'],
})
export class ContractorHotWorkPermitPage implements OnInit {
  isToggleMenu: boolean = false;
  isFormSubmited = false;
  customSegment: number = 1;
  segment:number = 1;
  disableSegment1: boolean = false;
  disableSegment2: boolean = false;
  disableSegment3: boolean = false;
  siteOfWorkContainsOther: boolean = false;
  activitiesContainsOther: boolean = false;
  hotWorkPermitId: number;
  hotWorkPermitNo: any;
  workDetailData: any[] = [];
  siteOfWorkArray: any = [];
  activitiesArray: any = [];
  PPEArray:any = [];
  MISCArray:any = [];
  hoursArray: any [];
  systemCurrentDate: any;
  hotWorkPermitFormGroup: FormGroup;
  roundsAndObservationsFormGroup: FormGroup;
  contractorReportFormGroup: FormGroup;
  loadingRef: HTMLIonLoadingElement;
  HotWorkPermitSignatureType = HotWorkPermitSignatureType;
  signitureSubscription: Subscription;
  signatureUploadSubscription: Subscription;
  hazardList = [
    {
      assoHazardId: 1,
      assHazard: 'Fire in combustible material in vicinity of Hot Work.',
      precaution: 'Work area clear of combustible materials',
      answers: 'NA',
      srNo: 'A',
      respNo: 1,
      rowSpan: 3,
      isShowData: true,
      preSafetyId: 1,
    },
    {
      assoHazardId: 1,
      preSafetyId: 2,
      assHazard: 'Fire in combustible material in vicinity of Hot Work.',
      precaution: 'Fire blanket/shield/metallic container available at site.',
      answers: 'NA',
      srNo: 'A',
      respNo: 1,
      isShowData: false,
    },
    {
      assoHazardId: 1,
      preSafetyId: 3,
      assHazard: 'Fire in combustible material in vicinity of Hot Work.',
      precaution: 'Barricading of the floor below work area.',
      answers: 'NA',
      srNo: 'A',
      respNo: 1,
      isShowData: false
    },
    {
      assoHazardId: 2,
      preSafetyId: 4,
      assHazard: 'Fire from GAS cutting Sets',
      precaution: 'Flash back arrestor provided to lines',
      answers: 'NA',
      srNo: 'B',
      respNo: 3,
      rowSpan: 2,
      isShowData: true
    },
    {
      assoHazardId: 2,
      preSafetyId: 5,
      assHazard: 'Fire from GAS cutting Sets',
      precaution: 'All hoses/gas pipes in good condition without any joint.',
      answers: 'NA',
      srNo: 'B',
      respNo: 2,
      isShowData: false
    },
    {
      assoHazardId: 3,
      preSafetyId: 6,
      assHazard: 'Fire or Explosion due to presence of Flammable Gases or Vapors',
      precaution: 'Periodic Gas test required',
      answers: 'NA',
      srNo: 'C',
      respNo: 3,
      isShowData: true
    },
    {
      assoHazardId: 4,
      preSafetyId: 7,
      assHazard: 'Injury or damage due to falling of objects from height.',
      precaution: 'Provide safety net where required, barricading of work area.',
      answers: 'NA',
      srNo: 'D',
      respNo: 4,
      isShowData: true
    },
    {
      assoHazardId: 5,
      preSafetyId: 8,
      assHazard: 'Electrocution to person and equipment due to welding m/c.',
      precaution: 'ELCB, 30 mA provided.',
      answers: 'NA',
      srNo: 'E',
      respNo: 5,
      rowSpan: 2,
      isShowData: true
    },
    {
      assoHazardId: 5,
      preSafetyId: 9,
      assHazard: 'Electrocution to person and equipment due to welding m/c.',
      precaution: 'Leather hand gloves and safety shoes used by welder during work.',
      answers: 'NA',
      srNo: 'E',
      respNo: 5,
      isShowData: false
    },
    {
      assoHazardId: 6,
      preSafetyId: 10,
      assHazard: 'Damage to other electrical equipment’s due to high current flow from weld operation.',
      precaution: 'Both electrodes fixed to the piece being welded.',
      answers: 'NA',
      srNo: 'F',
      respNo: 6,
      isShowData: true
    },
  ]
  constructor(public fb: FormBuilder, 
    private contractorHotWorkPermitService: ContractorHotWorkPermitService,
    public loadingController: LoadingController,
    public alertController: AlertController,
    public activatedRoutes: ActivatedRoute,
    public modalController: ModalController,
    public datePipe: DatePipe,
    public timeFormat: TimeFormatPipe) { }

  ngOnInit() {
    this.systemCurrentDate =  new Date();
    this.disableSegment1 = true;
    this.hotWorkPermitId = this.activatedRoutes?.snapshot?.queryParams?.id;
    this.hotWorkPermitFormGroup = this.PrepareWorkDetailForm();
    this.roundsAndObservationsFormGroup = this.prepareRoundsObservationForm();
    this.contractorReportFormGroup = this.preparContractorReportForm();
    this.setHWPExtentionArray();
    this.setHazardsFormArray();
    this.getHotWorkPermitDetails(this.hotWorkPermitId);
    this.hideLoaderIfExist();
  }
  async hideLoaderIfExist() {
    if (this.loadingRef) {
      this.loadingRef?.dismiss();
    }
    const data = await this.loadingController?.getTop();
    if (data) {
      data?.dismiss();
    }
  }
  getHotWorkPermitDetails(id){
    this.contractorHotWorkPermitService.callGetApiByID('api/contractorHotWorkPermit/get-all-Data-by-id',id).subscribe((data) => {
      if(data.data){
        this.workDetailData = data.data.hotWorkPermit;
        this.hotWorkPermitNo = data.data.hotWorkPermit.hotWorkPermitNo;
        this.setReportFormArray();
        this.setWorkDetailsData(data.data.hotWorkPermit);
        this.setHazardsData(data.data.listHazardAnswers);
        this.setGasTestDeailsData(data.data);
        this.setEquipmentData(data.data.listOfEquipmentAnswers);
        this.setInspectionData(data.data.listInspectionByFireTeam);
        this.setApprovalSignData(data.data.listHotWorkPermitApproval);
        this.setHWPExtentionData(data.data.listHotWorkPermitExtension);
        this.setRoundsAndObservationData(data.data.listRoundAndObservation);
        this.setViolationData(data.data.listHotWorkPermitViolations);
        this.setViolationSignData(data.data.listHotWorkPermitViolationsSign);
        this.setClosureSignData(data.data.listHotWorkPermitClosure);
        this.setReportData(data.data.hotWorkPermitContractorReporting);
        console.log(this.hotWorkPermitFormGroup,this.roundsAndObservationsFormGroup,this.contractorReportFormGroup);
      }
    })
  }
  //functions related to Form control
  PrepareWorkDetailForm(){
    return this.fb.group({
      workDetails: this.contractorHotWorkPermitService.getHotWorkPermitFormDetails(),
      hazardDetails: this.fb.array([this.contractorHotWorkPermitService.getHazardDetails()]),
      levelTestDetails: this.fb.array([this.contractorHotWorkPermitService.getLevelTestDetails()]),
      oxygenTestDetails: this.fb.array([this.contractorHotWorkPermitService.getOxygenTestDetails()]),
      coTestDetails: this.fb.array([this.contractorHotWorkPermitService.getCoTestDetails()]),
      h2sTestDetails: this.fb.array([this.contractorHotWorkPermitService.getH2sTestDetails()]),
      equipmentDetails: this.contractorHotWorkPermitService.getEquipmentDetails(),
      listOfInspection: this.contractorHotWorkPermitService.getInspectionList(),
      hwpContractorApprovalSignature: this.contractorHotWorkPermitService.getHotWorkPermitSignature(),
      hwpOptDeptApprovalSignaure: this.contractorHotWorkPermitService.getHotWorkPermitSignatureNotMandetory(),
      hwpExeDepApprovalSignature: this.contractorHotWorkPermitService.getHotWorkPermitSignatureNotMandetory(),
      hwpFireSafetyDepApprovalSignature: this.contractorHotWorkPermitService.getHotWorkPermitSignatureNotMandetory(),
      hwpExtention: this.fb.array([this.contractorHotWorkPermitService.getHWPExtention()])
    })
  }
  prepareRoundsObservationForm(){
    return this.fb.group(
      {
        roundsObservation: this.fb.array([this.contractorHotWorkPermitService.getRoundsObservationDetails()]),
        hwpContractorClosureSignature: this.contractorHotWorkPermitService.getHotWorkPermitSignatureNotMandetory(),
        hwpOptDeptClosureSignaure: this.contractorHotWorkPermitService.getHotWorkPermitSignatureNotMandetory(),
        hwpExeDepClosureSignature: this.contractorHotWorkPermitService.getHotWorkPermitSignatureNotMandetory(),
        hwpViolation: this.fb.array([this.contractorHotWorkPermitService.getHotWorkPermitViolation()]),
        hwpViolationSign: this.contractorHotWorkPermitService.getHotWorkPermitViolationSignature()
      }
    )
  }
  preparContractorReportForm(){
    return this.fb.group({
      report: this.fb.array([this.contractorHotWorkPermitService.getReport()])
    });
  }
  setHazardsFormArray(){
    for(let i=0; i < this.hazardList?.length; i++){
      if(i < this.hazardList.length-1){
        const hazardControl = <FormArray>this.hotWorkPermitFormGroup.controls['hazardDetails']
        hazardControl.push(this.contractorHotWorkPermitService.getHazardDetails())
      }
      const prepareData = {
        assoHazardId: this.hazardList[i].assoHazardId,
        preSafetyId: this.hazardList[i].preSafetyId
      }
      const row = this.hotWorkPermitFormGroup.get('hazardDetails') as FormArray;
      row.controls[i].patchValue({...prepareData})
    }
  }
  setHWPExtentionArray(){
    for(let i = 0; i < 7; i++){
      if(i < 6){
        const reportControl = <FormArray>this.hotWorkPermitFormGroup.controls['hwpExtention'];
        reportControl.push(this.contractorHotWorkPermitService.getHWPExtention());
      }
      const prepareData = {
        day: 'Day ' + (i+1)
      }
      const row = this.hotWorkPermitFormGroup.get('hwpExtention') as FormArray;
      row.controls[i].patchValue({...prepareData});
    }
  }
  setReportFormArray(){
    var date1 = new Date (this.workDetailData['fromDate']);
    var date2 = new Date(this.workDetailData['toDate']);
    var reportDates = [];
    while(date1<=date2){
      reportDates.push(this.datePipe.transform(date1))
      date1.setDate(date1.getDate()+1);
    }
    for(let i = 0; i < reportDates.length; i++){
      if(i < reportDates.length-1){
        const reportControl = <FormArray>this.contractorReportFormGroup.controls['report'];
        reportControl.push(this.contractorHotWorkPermitService.getReport());
      }
      const prepareData = {
        date: new Date(reportDates[i]),
        day: 'Day ' + (i+1)
      }
      const row = this.contractorReportFormGroup.get('report') as FormArray;
      row.controls[i].patchValue({...prepareData});
    }
    console.log("ReportData!!",this.contractorReportFormGroup.controls.report)
  }
  get workDetailsFormGroup(){
    return this.hotWorkPermitFormGroup.get('workDetails');
  }
  get hazardDetailsFormGroup(){
    return (this.hotWorkPermitFormGroup.get('hazardDetails'));
  }
  get levelTestFormGroup(){
    return (this.hotWorkPermitFormGroup.get('levelTestDetails'));
  }
  get oxygenTestFormGroup(){
    return (this.hotWorkPermitFormGroup.get('oxygenTestDetails'));
  }
  get coTestFormGroup(){
    return (this.hotWorkPermitFormGroup.get('coTestDetails'));
  }
  get h2sTestFormGroup(){
    return (this.hotWorkPermitFormGroup.get('h2sTestDetails'))
  }
  get equipmentDetailsFormGroup(){
    return this.hotWorkPermitFormGroup.get('equipmentDetails');
  }
  get ListOfInspectionFormGroup(){
    return this.hotWorkPermitFormGroup.get('listOfInspection');
  }
  get hwpContractorApprovalSignatureFormGroup(){
    return (this.hotWorkPermitFormGroup.get('hwpContractorApprovalSignature'));
  }
  get hwpOptDeptApprovalSignaureFormGroup(){
    return (this.hotWorkPermitFormGroup.get('hwpOptDeptApprovalSignaure'));
  }
  get hwpExeDepApprovalSignatureFormGroup(){
    return (this.hotWorkPermitFormGroup.get('hwpExeDepApprovalSignature'));
  }
  get hwpFireSafetyDepApprovalSignatureFormGroup(){
    return (this.hotWorkPermitFormGroup.get('hwpFireSafetyDepApprovalSignature'));
  }
  get hwpExtentionFormGroup(){
    return (this.hotWorkPermitFormGroup.get('hwpExtention'));
  }
  get roundsDetialsFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('roundsObservation');
  }
  get violationFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('hwpViolation');
  }
  get violationSignFormGroup(){
    return this.roundsAndObservationsFormGroup.get('hwpViolationSign');
  }
  get hwpContractorClosureSignatureFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('hwpContractorClosureSignature');
  }
  get hwpOptDeptClosureSignaureFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('hwpOptDeptClosureSignaure');
  }
  get hwpExeDepClosureSignatureFormGroup(){
    return  this.roundsAndObservationsFormGroup.get('hwpExeDepClosureSignature');
  }
  get reportFormGroup(){
    return this.contractorReportFormGroup.get('report')
  }
  setWorkDetailsData(hotWorkPermit){
    if(hotWorkPermit){
      this.siteOfWorkArray = [];
      this.activitiesArray = [];
      this.siteOfWorkArray = hotWorkPermit?.siteOfWork?.split(',');
      this.activitiesArray = hotWorkPermit?.activitiesNeeded?.split(',');
      this.siteOfWorkContainsOther = this.siteOfWorkArray.includes('Other');
      this.activitiesContainsOther = this.activitiesArray.includes('Other');
      this.hotWorkPermitFormGroup.controls.workDetails.value.siteOfWork.forEach((item1, i) => {
        if(this.siteOfWorkArray.find(item2 => item2.toLowerCase() === item1.name.toLocaleLowerCase())){
          item1.checked = true;
        }else{
          item1.checked = false;
        }
      });
      this.hotWorkPermitFormGroup.controls.workDetails.value.activitiesNeeded.forEach((data1,i) => {
        if(this.activitiesArray.find((data2) => data2.toLocaleLowerCase() === data1.name.toLocaleLowerCase())){
        data1.checked = true;
        }else{
          data1.checked = false;
        }
      });
      this.hotWorkPermitFormGroup.controls.workDetails.patchValue({
        ...hotWorkPermit,
        savwiplexecutingDept: hotWorkPermit.savwiplexecutingDept?.areaName,
        savwiplexecutivingDeptPerson: hotWorkPermit.savwiplexecutivingDeptPerson?.firstName + `${' '}` + hotWorkPermit.savwiplexecutivingDeptPerson?.lastName,
        savwiploperationDept: hotWorkPermit.savwiploperationDept?.areaName,
        savwiploperationDeptPerson: hotWorkPermit.savwiploperationDeptPerson?.firstName + `${' '}` + hotWorkPermit.savwiploperationDeptPerson?.lastName,
        siteOfWork: [],
        activitiesNeeded: [],
        fromTime: this.timeFormat.transform(hotWorkPermit.fromTime),
        toTime: this.timeFormat.transform(hotWorkPermit.toTime)
      });
    }
  }
  setHazardsData(hazards){
    for(let j = 0 ; j < hazards?.length ; j++){
      const prepareData = {
        answers: hazards[j].answers,
      }
      const row = this.hotWorkPermitFormGroup.get('hazardDetails') as FormArray;
      row.controls[j].patchValue({...prepareData})
    }
  }
  setGasTestDeailsData(data){
    if( data?.listLevelTest?.length > 0){
      for(let i = 0; i < data.listLevelTest.length; i++){
        let prepareData = {};
        if(i < data.listLevelTest.length-1){
          const control1 = <FormArray>this.hotWorkPermitFormGroup.controls['levelTestDetails'];
          control1.push(this.contractorHotWorkPermitService.getLevelTestDetails());
        }
        prepareData = {
          ...data.listLevelTest[i],
          lELTime: this.timeFormat.transform(data.listLevelTest[i].lELTime)
        }
        const row1 = this.hotWorkPermitFormGroup.get('levelTestDetails') as FormArray;
        row1.controls[i].patchValue({...prepareData})
      }
    }else{
      const control = <FormArray>this.hotWorkPermitFormGroup.controls['levelTestDetails'];
      control.removeAt(0);
    }
    if(data?.listOfOxygenTest?.length > 0){
      for(let i = 0; i < data.listOfOxygenTest.length; i++){
        let prepareData = {}
        if(i < data.listOfOxygenTest.length-1){
          const control1 = <FormArray>this.hotWorkPermitFormGroup.controls['oxygenTestDetails'];
          control1.push(this.contractorHotWorkPermitService.getOxygenTestDetails());
        }
        prepareData = {
          ...data.listOfOxygenTest[i],
          oxygenRequired: this.timeFormat.transform(data.listOfOxygenTest[i].oxygenRequired)
        }
        const row1 = this.hotWorkPermitFormGroup.get('oxygenTestDetails') as FormArray;
        row1.controls[i].patchValue({...prepareData});
      }
    }else{
      const control = <FormArray>this.hotWorkPermitFormGroup.controls['oxygenTestDetails'];
      control.removeAt(0);
    }
    if(data?.listOfCoppmTest?.length > 0){
      for(let i = 0; i < data.listOfCoppmTest.length; i++){
        let prepareData = {};
        if(i < data.listOfCoppmTest.length-1){
          const control1 = <FormArray>this.hotWorkPermitFormGroup.controls['coTestDetails'];
          control1.push(this.contractorHotWorkPermitService.getCoTestDetails());
        }
        prepareData = {
          ...data.listOfCoppmTest[i],
          coTime: this.timeFormat.transform(data.listOfCoppmTest[i].coTime)
        }
        const row1 = this.hotWorkPermitFormGroup.get('coTestDetails') as FormArray;
        row1.controls[i].patchValue({...prepareData});
      }
    }else{
      const control = <FormArray>this.hotWorkPermitFormGroup.controls['coTestDetails'];
      control.removeAt(0);
    }
    if(data?.listOfH2sppmTest?.length > 0){
      for(let i = 0; i < data.listOfH2sppmTest.length; i++){
        let prepareData = {};
        if(i < data.listOfH2sppmTest.length-1){
          const control1 = <FormArray>this.hotWorkPermitFormGroup.controls['h2sTestDetails'];
          control1.push(this.contractorHotWorkPermitService.getH2sTestDetails());
        }
        prepareData = {
          ...data.listOfH2sppmTest[i],
          h2sTime: this.timeFormat.transform(data.listOfH2sppmTest[i].h2sTime)
        }
        const row1 = this.hotWorkPermitFormGroup.get('h2sTestDetails') as FormArray;
        row1.controls[i].patchValue({...prepareData});
      }
    }else{
      const control = <FormArray>this.hotWorkPermitFormGroup.controls['h2sTestDetails'];
      control.removeAt(0);
    }
  }
  setEquipmentData(listOfEquipmentAnswers){
    if(listOfEquipmentAnswers){
      this.PPEArray = [];
      this.MISCArray = [];
      this.PPEArray = listOfEquipmentAnswers?.ppe?.split(',');
      this.MISCArray = listOfEquipmentAnswers?.misc?.split(',');
      this.hotWorkPermitFormGroup.controls.equipmentDetails.value.PPE.forEach((data,i) => {
        if(this.PPEArray?.find(item => item.toLowerCase() === data.name.toLowerCase())){
          data.checked = true
        }else{
          data.checked = false
        }
      });
      this.hotWorkPermitFormGroup.controls.equipmentDetails.value.MISC.forEach((data,i) => {
        if(this.MISCArray?.find(item => item.toLowerCase() === data.name.toLowerCase())){
          data.checked = true
        }else{
          data.checked = false
        }
      });
    }
  }
  setInspectionData(listInspectionByFireTeam){
    if(listInspectionByFireTeam){
      this.hoursArray = [];
      this.hoursArray = listInspectionByFireTeam[0]?.hours?.split(',');
      // listInspectionByFireTeam.forEach((item)=>{
      //   this.hoursArray.push(item.hours)
      // })
      this.hotWorkPermitFormGroup.controls.listOfInspection.value.forEach((data,i) => {
        if(this.hoursArray?.find(item => item.toLowerCase() === data.name.toLocaleLowerCase())){
          data.checked = true
        }else{
          data.checked = false
        }
      });
    }
  }
  setApprovalSignData(approvalSign){
    if(this.workDetailData['signature']){
      const prepareHWPContractorApprovalSignature = {
        ...this.workDetailData,
        name: this.workDetailData['nameOfContractor'],
        userType: 'Contractor'
      }
      this.hotWorkPermitFormGroup.controls.hwpContractorApprovalSignature.patchValue({
        ...prepareHWPContractorApprovalSignature
      });
    }
    if(approvalSign.length > 0){
      approvalSign.forEach((item) =>{
        const prepareData = {
          ...item,
          name: item?.responsiblePerson['firstName'] + `${' '}`+ item?.responsiblePerson['lastName']
        }
        if(item.userType == "Operating Department"){
          this.hotWorkPermitFormGroup.controls.hwpOptDeptApprovalSignaure.patchValue({
            ...prepareData
          });
        }else if(item.userType == "Fire Safety Department"){
          this.hotWorkPermitFormGroup.controls.hwpFireSafetyDepApprovalSignature.patchValue({
            ...prepareData
          });
        }else if(item.userType == "Executing Department"){
          this.hotWorkPermitFormGroup.controls.hwpExeDepApprovalSignature.patchValue({
            ...prepareData
          });
        }
      })
    }
  }
  setHWPExtentionData(listHotWorkPermitExtension){
    console.log("listHotWorkPermitExtension",listHotWorkPermitExtension);
    for(let i = 0; i < listHotWorkPermitExtension?.length; i++){
      const prepareData = {
        date: this.datePipe.transform(listHotWorkPermitExtension[i].date,"dd-MM-yyyy"),
        shiftOrTime: listHotWorkPermitExtension[i].shift,
        signature: listHotWorkPermitExtension[i].signature,
        id:listHotWorkPermitExtension[i].id
      }
      const row = this.hotWorkPermitFormGroup.get('hwpExtention') as FormArray;
      row.controls[i].patchValue({...prepareData});
    }
  }
  setRoundsAndObservationData(listRoundAndObservation){
    if(listRoundAndObservation?.length > 0){
      for(let i = 0; i < listRoundAndObservation?.length; i++){
        if(i < listRoundAndObservation.length-1){
          const control = <FormArray>this.roundsAndObservationsFormGroup.controls['roundsObservation'];
          control.push(this.contractorHotWorkPermitService.getRoundsObservationDetails())
        }
        const row = this.roundsAndObservationsFormGroup.get('roundsObservation') as FormArray
        row.controls[i].patchValue({...listRoundAndObservation[i]})
        if(listRoundAndObservation[i].signature){
          const prepareData = {
            signature: listRoundAndObservation[i].signature,
            fileName: listRoundAndObservation[i].fileName,
            name: listRoundAndObservation[i].user?.firstName + `${' '}`+ listRoundAndObservation[i].user?.lastName
          }
          this.roundsAndObservationsFormGroup.controls.hwpViolationSign.patchValue({
            fireSafetyDept: prepareData
          });
          console.log("Sign!!",listRoundAndObservation[i].signature);
        }
      } 
    }else{
      const control = <FormArray>this.roundsAndObservationsFormGroup.controls['roundsObservation'];
      control.removeAt(0);
    }
  }
  setViolationData(violation){
    if(violation?.length > 0){
      for(let i = 0; i < violation.length; i++){
        if(i < violation.length-1){
          const control = <FormArray>this.roundsAndObservationsFormGroup.controls['hwpViolation'];
          control.push(this.contractorHotWorkPermitService.getHotWorkPermitViolation());
        }
        const row = this.roundsAndObservationsFormGroup.get('hwpViolation') as FormArray
        row.controls[i].patchValue({...violation[i]});
      }
    }else{
      const control = <FormArray>this.roundsAndObservationsFormGroup.controls['hwpViolation'];
      control.removeAt(0);
    }
  }
  setViolationSignData(violationSign){
    if(violationSign?.length > 0){
      violationSign.forEach((item) =>{
        const prepareData = {
          ...item,
          name: item.userId?.firstName + `${' '}`+ item.userId?.lastName
        }
        if(item.userType == "Operating Department"){
          this.roundsAndObservationsFormGroup.controls.hwpViolationSign.patchValue({
            optDept: prepareData
          });
        }else if(item.userType == "Executing Department"){
          this.roundsAndObservationsFormGroup.controls.hwpViolationSign.patchValue({
            exeDept: prepareData
          });
        }else if(item.userType == "Contractor"){
          this.roundsAndObservationsFormGroup.controls.hwpViolationSign.patchValue({
            contractor: prepareData
          });
        }/* else if(item.userType == "Fire Safety Department"){
          this.roundsAndObservationsFormGroup.controls.hwpViolationSign.patchValue({
            fireSafetyDept: prepareData
          });
        } */
      })
    }
  }
  setClosureSignData(closureSign){
    if(closureSign?.length > 0){
      closureSign.forEach((item) =>{
        const prepareData = {
          ...item,
          id: item.id,
          name: item.respPerson?.firstName + `${' '}`+ item.respPerson?.lastName
        }
        if(item.userType == "Operating Department"){
          this.roundsAndObservationsFormGroup.controls.hwpOptDeptClosureSignaure.patchValue({
            ...prepareData
          });
        }else if(item.userType == "Executing Department"){
          this.roundsAndObservationsFormGroup.controls.hwpExeDepClosureSignature.patchValue({
            ...prepareData
          });
        }else if(item.userType == "Contractor"){
          this.roundsAndObservationsFormGroup.controls.hwpContractorClosureSignature.patchValue({
            ...prepareData
          });
        }
      })
    }
  }
  setReportData(hotWorkPermitContractorReporting){
    for(let i = 0; i < hotWorkPermitContractorReporting?.length; i++){
      console.log(hotWorkPermitContractorReporting[i].date,this.datePipe.transform(this.contractorReportFormGroup.controls.report.value[i]['date'], "dd-MM-yyyy"))
      if(hotWorkPermitContractorReporting[i].date === this.datePipe.transform(this.contractorReportFormGroup.controls.report.value[i]['date'], "dd-MM-yyyy")){
        const prepareData = {
          fileName: hotWorkPermitContractorReporting[i].fileName,
          signature: hotWorkPermitContractorReporting[i].signature,
          checkIn: hotWorkPermitContractorReporting[i].checkIn,
          chechInTime: this.timeFormat.transform(hotWorkPermitContractorReporting[i].chechInTime),
          chechOutTime: this.timeFormat.transform(hotWorkPermitContractorReporting[i].chechOutTime),
          id: hotWorkPermitContractorReporting[i].id
        }
        console.log("Prepare",prepareData)
        const row = this.contractorReportFormGroup.get('report') as FormArray;
        row.controls[i].patchValue({...prepareData});
      }
    }
  }
  async addSignature(type){
    if(this.signitureSubscription){
      this.signitureSubscription.unsubscribe();
    }
    const eventEmitterSubject = new EventEmitter;
    this.signitureSubscription = eventEmitterSubject.subscribe(res => {
      console.log("res!",res)
      if(type == HotWorkPermitSignatureType.contractorApprovalSignature){
        this.uploadContractorApprovalsignature(res)
      }
      if(type == HotWorkPermitSignatureType.contractorClosureSignature){
        this.uploadContractorClosuresignature(res)
      }
      if(type == HotWorkPermitSignatureType.contractorViolationSignature){
        this.uploadContractorViolationsignature(res)
      }
    });
    const modal = await this.modalController.create({
      component: AddSignatureModal,
      componentProps: {
        isShowContractorInput:  false,
        isShowContractorInputReadOnly: true,
        NameOfContractor: this.workDetailData['nameOfContractor'],
        onUpload: eventEmitterSubject
      },
      cssClass: 'addSign',
      animated: true,
      backdropDismiss: false
    });
    return await modal.present();
  }
  uploadContractorApprovalsignature({ formData, fileName, fileType, name }){
    this.showLoader();
    this.contractorHotWorkPermitService.uploadSign(`api/contractorHotWorkPermit/uploadFile?fileName=${fileName}&fileType=${fileType}`,formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe((data) => {
        if(data){
          console.log("Response!!",data);
          this.hotWorkPermitFormGroup.controls.hwpContractorApprovalSignature.patchValue({
            signature: data['data'][0]['filePath'],
            fileName: fileName
          })
          this.uploadSuccessMessage();
        }
      },
      (error) => {
        this.loadingRef?.dismiss();
        console.log("Something went wrong");
      }
    )
  }
  uploadContractorClosuresignature({ formData, fileName, fileType, name }){
    this.showLoader();
    this.contractorHotWorkPermitService.uploadSign(`api/contractorHotWorkPermit/uploadFile?fileName=${fileName}&fileType=${fileType}`,formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe((data) => {
        if(data){
          console.log("Response!!",data);
          this.roundsAndObservationsFormGroup.controls.hwpContractorClosureSignature.patchValue({
            signature: data['data'][0]['filePath'],
            fileName: fileName,
            userType: "Contractor",
            date: this.datePipe.transform(new Date(),"dd-MM-yyyy")
          })
          this.uploadSuccessMessage();
        }
      },
      (error) => {
        this.loadingRef?.dismiss();
        console.log("Something went wrong");
      }
    )
  }
  uploadContractorViolationsignature({ formData, fileName, fileType, name }){
    this.showLoader();
    this.contractorHotWorkPermitService.uploadSign(`api/contractorHotWorkPermit/uploadFile?fileName=${fileName}&fileType=${fileType}`,formData)
      .pipe(finalize(() => {
        this.modalController.dismiss();
        this.loadingRef?.dismiss();
      }))
      .subscribe((data) => {
        if(data){
          console.log("Response!!",data);
          const prepareData = {
            signature: data['data'][0]['filePath'],
            fileName: fileName,
            userType: "Contractor",
            date: this.datePipe.transform(new Date(),"dd-MM-yyyy")
          }
          this.roundsAndObservationsFormGroup.controls.hwpViolationSign.patchValue({
            contractor: prepareData
          })
          this.uploadSuccessMessage();
        }
      },
      (error) => {
        this.loadingRef?.dismiss();
        console.log("Something went wrong");
      }
    )
  }
  //Function related to segments
  segmentChanged(event){
    setTimeout(() => {
      this.segment = event.detail.value;
      this.customSegment = event.detail.value;
      document.getElementById('ion-segment-' + event.detail.value)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
    });
  }
  goToPrevious(){
    this.segment = --this.segment;
    this.customSegment = this.segment
  }
  hwpContractorSignFlag = false
  goToNext(){
    if(this.segment == 1){
      if(this.hotWorkPermitFormGroup.valid || this.hwpContractorApprovalSignatureFormGroup.valid){
        this.disableSegment2 = true;
        this.segment = ++this.segment
        this.customSegment = this.segment;
      }else{
        this.hwpContractorSignFlag = true;
        this.hotWorkPermitFormGroup.markAsDirty();
        this.hotWorkPermitFormGroup.markAllAsTouched();
        this.errorAlert('Please fill all mandatory details');
      }
    }else if(this.segment == 2){
      if(this.roundsAndObservationsFormGroup.valid){
        this.disableSegment3 = true;
        this.segment = ++this.segment
        this.customSegment = this.segment;
      }else{
        this.roundsAndObservationsFormGroup.markAsDirty();
        this.roundsAndObservationsFormGroup.markAllAsTouched();
        this.errorAlert('Please fill all mandatory details');
      }
    }
  }
  formSubmit(){
    if(this.roundsAndObservationsFormGroup.valid){
      let reportData = [];
      for(let i = 0; i < this.contractorReportFormGroup.controls.report.value.length; i++){
        if(this.contractorReportFormGroup.controls.report.value[i].chechInTime){
          const object = {
            chechInTime: this.contractorReportFormGroup.controls.report.value[i]['chechInTime'],
            chechOutTime: this.contractorReportFormGroup.controls.report.value[i]['chechOutTime'],
            checkIn: this.contractorReportFormGroup.controls.report.value[i]['checkIn'],
            date: this.datePipe.transform(this.contractorReportFormGroup.controls.report.value[i]['date'],"dd-MM-YYY"),
            day: this.contractorReportFormGroup.controls.report.value[i]['day'],
            fileName: this.contractorReportFormGroup.controls.report.value[i]['fileName'],
            id: this.contractorReportFormGroup.controls.report.value[i]['id'],
            signature: this.contractorReportFormGroup.controls.report.value[i]['signature']
          }
          reportData.push(object);
        }
      }
      let hotWorkPermitClosureRequest = {
        "date": this.roundsAndObservationsFormGroup.controls.hwpContractorClosureSignature.get('date').value,
        //"department": "NonEmpty String",
        "fileData": {},
        "fileName": this.roundsAndObservationsFormGroup.controls.hwpContractorClosureSignature.get('fileName').value,
        "hwpNo": this.hotWorkPermitNo,
        "id": this.roundsAndObservationsFormGroup.controls.hwpContractorClosureSignature.get('id').value,
        "responsiblePerson": null,
        "signUserType": "Contractor",
        "signature": this.roundsAndObservationsFormGroup.controls.hwpContractorClosureSignature.get('signature').value,
        "userType": "Contractor"
      }
      console.log("ReportData",reportData)
      const request = {
        "hazardIdentificationAnswers": this.hotWorkPermitFormGroup.controls.hazardDetails.value,
        "hotWorkPermitClosureRequest": this.roundsAndObservationsFormGroup.controls.hwpContractorClosureSignature.get('signature').value ? hotWorkPermitClosureRequest : null,
        "hotWorkPermitContractorReportingRequest": reportData,
        "voilationSignatureRequest": this.roundsAndObservationsFormGroup.controls.hwpViolationSign.get('contractor').value['signature'] ? this.roundsAndObservationsFormGroup.controls.hwpViolationSign.value.contractor : null,
        "hwpId": this.workDetailData['id'],
        "workDetails": {
          "activitiesNeeded": this.workDetailData['activitiesNeeded'],
          "columnNo": this.workDetailData['columnNo'],
          "contractAgency": this.workDetailData['contractAgency'],
          "dateOfIssue": this.workDetailData['dateOfIssue'],
          "emailOfContractor": this.workDetailData['emailOfContractor'],
          "fileName": this.hotWorkPermitFormGroup.controls.hwpContractorApprovalSignature.get('fileName').value,
          "fromDate": this.workDetailData['fromDate'],
          "fromTime": this.workDetailData['fromTime'],
          "hotWorkPermitNo": this.workDetailData['hotWorkPermitNo'],
          "id": this.workDetailData['id'],
          "isDraft": false,
          "issuedBy": this.workDetailData['issuedBy']['id'],
          "locationOfWork": this.workDetailData['locationOfWork'],
          "mobileNoOfContractor": this.workDetailData['mobileNoOfContractor'],
          "nameOfContractor": this.workDetailData['nameOfContractor'],
          "otherActivitiesNeeded": this.workDetailData['otherActivitiesNeeded'],
          "otherLocationOfWork": this.workDetailData['otherLocationOfWork'],
          "otherSiteOfWork": this.workDetailData['otherSiteOfWork'],
          "remark": this.workDetailData['remark'],
          "savwiplexecutingDept": this.workDetailData['savwiplexecutingDept']['id'],
          "savwiplexecutivingDeptPerson": this.workDetailData['savwiplexecutivingDeptPerson']['id'],
          "savwiploperationDept": this.workDetailData['savwiploperationDept']['id'],
          "savwiploperationDeptPerson": this.workDetailData['savwiploperationDeptPerson']['id'],
          "scopeOfWork": this.workDetailData['scopeOfWork'],
          "signature": this.hotWorkPermitFormGroup.controls.hwpContractorApprovalSignature.get('signature').value,
          "siteOfWork": this.workDetailData['siteOfWork'],
          "status": this.workDetailData['status'],
          "toDate": this.workDetailData['toDate'],
          "toTime": this.workDetailData['toTime'],
        }
      }
      this.showLoader();
      this.contractorHotWorkPermitService.addOrUpdateWorkPermitContractor(`/api/contractorHotWorkPermit/add-or-update-hot-workPermit-contractor`,request)
      .pipe(finalize(() => this.loadingRef?.dismiss()))
      .subscribe((resp: any) => {
        if(resp){
          this.isFormSubmited = true;
        }
      },error => { console.log("Error!!",error)});
    }else{
      this.roundsAndObservationsFormGroup.markAsDirty();
      this.roundsAndObservationsFormGroup.markAllAsTouched();
      this.errorAlert('Please fill all mandatory details');
    }
  }
  async errorAlert(msg) {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'error-alert',
      header: '',
      message: `<p class="warning-text-header"><ion-icon name="information-circle-outline" color="warning"></ion-icon></p>
                ${msg}`,
      buttons:  [{
                    text: 'ok', role: 'Ok', cssClass: 'ok', handler: () => {alert.dismiss();}
                }]
    });
    await alert.present();
  }
  async uploadSuccessMessage(message = 'Your signature has been uploaded successfully.') {
    const alert = await this.alertController.create({
      animated: true,
      cssClass: 'saveAsDraftAlert Succuss2',
      header: '',
      message,
      buttons: [{ text: 'OK', role: 'cancel', cssClass: 'ok' }]
    });
    await alert.present();
  }
  async showLoader(msg = 'Please wait...') {
    if (this.loadingRef) {
      this.loadingRef?.dismiss()
    }
    this.loadingRef = await this.loadingController.create({
      duration: 6000,
      cssClass: 'please-wait',
      message: msg,
      translucent: true,
      backdropDismiss: true
    });
    await this.loadingRef.present();
  }
  clickToCheckInCheckOutDisabled(item): boolean {
    return this.workDetailsFormGroup.get('status').value != 'In-progress' || (this.datePipe.transform(this.systemCurrentDate,'yyyy-MM-dd') != this.datePipe.transform(item.value['date'],'yyyy-MM-dd'));
  }
  async clickToCheckIn(index,item){   
    const alert =  await this.alertController.create({
      animated: true,
      backdropDismiss: false,
      cssClass: 'saveAsDraftAlert',
      header: 'ARE YOU SURE',
      message : 'Do you want to check in?',
      buttons: [
        { text: 'No', role: 'cancel', cssClass: 'cancel' },
        {
          text: 'Yes', role: 'Ok', cssClass: 'ok', handler: () => {
            item.value['chechInTime'] = this.datePipe.transform(new Date(), 'HH:mm a');
          }
        }
      ]
    });
    await alert.present();
  }
  async clickToCheckOut(index,item){
    const alert =  await this.alertController.create({
      animated: true,
      backdropDismiss: false,
      cssClass: 'saveAsDraftAlert',
      header: 'ARE YOU SURE',
      message : 'Do you want to check out?',
      buttons: [
        { text: 'No', role: 'cancel', cssClass: 'cancel' },
        {
          text: 'Yes', role: 'Ok', cssClass: 'ok', handler: () => {
            this.addReportSign(item);
          }
        }
      ]
    });
    await alert.present();
  }
  async addReportSign(item){
    if(this.signitureSubscription){
      this.signitureSubscription.unsubscribe();
    }
    const eventEmitterSubject = new EventEmitter;
    this.signitureSubscription = eventEmitterSubject.subscribe(res => {
      this.uploadReportSign(item,res);
    });
    const modal = await this.modalController.create({
      component: AddSignatureModal,
      componentProps: {
        isShowContractorInput:  false,
        onUpload: eventEmitterSubject
      },
      cssClass: 'addSign',
      animated: true,
      backdropDismiss: false
    });
    return await modal.present();
  }
  uploadReportSign(item,res){
    this.showLoader();
      this.contractorHotWorkPermitService.uploadSign(`api/contractorHotWorkPermit/uploadFile?fileName=${res.fileName}&fileType=${res.fileType}`,res.formData)
        .pipe(finalize(() => {
          this.modalController.dismiss();
          this.loadingRef?.dismiss();
        }))
        .subscribe((data) => {
          if(data){
            console.log("Response!!",data,res.fileName);
            item.value['signature'] = data['data'][0]['filePath'];
            item.value['fileName'] = res.fileName;
            item.value['chechOutTime'] = this.datePipe.transform(new Date(), 'HH:mm a');
            item.value['checkIn'] = false;
            this.uploadSuccessMessage();
          }
        },
        (error) => {
          this.loadingRef?.dismiss();
          console.log("Something went wrong");
        }
      )
  }
}

